import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
let PiButtomSelect = class PiButtomSelect extends Vue {
    constructor() {
        super(...arguments);
        this.selectId = "";
        this.isOpen = false;
    }
    "Watch.valueId"() {
        if (this.selectId != this.valueId) {
            this.selectId = this.valueId;
        }
    }
    /**
     * 显示名称
     */
    get nameShow() {
        let name = "";
        this.selectList.map((item) => {
            if (item.value == this.selectId) {
                name = item.label;
            }
        });
        return name;
    }
    /**
     * 选择下拉时
     */
    selectChange(val) {
        this.isOpen = false;
        this.$emit("value", val);
        this.$emit("on-change", val);
    }
    /**
     * 打开或者关闭时
     */
    visibleChange(val) {
        this.isOpen = val;
    }
    mounted() {
        this.selectId = this.valueId;
    }
};
__decorate([
    Prop({
        default: () => {
            return [];
        },
    })
], PiButtomSelect.prototype, "selectList", void 0);
__decorate([
    Prop({ default: "text" })
], PiButtomSelect.prototype, "type", void 0);
__decorate([
    Prop({ default: "" })
], PiButtomSelect.prototype, "icon", void 0);
__decorate([
    Prop({ default: "before" })
], PiButtomSelect.prototype, "iconPosition", void 0);
__decorate([
    Watch("valueId")
], PiButtomSelect.prototype, "Watch.valueId", null);
__decorate([
    Model("value", { type: String || Number })
], PiButtomSelect.prototype, "valueId", void 0);
PiButtomSelect = __decorate([
    Component
], PiButtomSelect);
export default PiButtomSelect;
